<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="filters.status" placeholder="请选择状态">
            <el-option label="所有" :value="1"></el-option>
            <el-option label="正常" :value="0"></el-option>
            <el-option label="归档" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.key" placeholder="编号/标题/工程/客户" @change="getProdTask"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.gradeName" filterable placeholder="请选择" @change="getProdTask" :clearable="true">
            <el-option v-for="item in baseData.GradeList" :key="item.Name" :label="item.Name"
              v-model="item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.orgCode" filterable placeholder="请选择" @change="getProdTask(1)">
            <el-option v-for="item in orgList" :key="item.OrgCode + 'Seach'" :label="item.Name"
              v-model="item.OrgCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker type="datetime" placeholder="计划时间" v-model="filters.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          -
          <el-date-picker type="datetime" placeholder="计划时间" v-model="filters.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.taskStatus" placeholder="请选择状态">
            <el-option label="所有" :value="-999"></el-option>
            <el-option label="已开盘" :value="0"></el-option>
            <el-option label="未开盘" :value="100"></el-option>
            <el-option label="暂停" :value="200"></el-option>
            <el-option label="完成" :value="300"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getProdTask(1)">查询</el-button>
          <el-button type="primary" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--列表-->
    <el-table :data="prodTask" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%" :border="true">
      <el-table-column label="编号" width="220">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleDetail(scope.row)">
            {{ scope.row.Code }}
          </el-link>
          <el-tag :type="scope.row.Status == 0 ? 'success' : 'info'" disable-transitions>
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
          <el-tag size="small" :type="scope.row.TaskStatus == 0
            ? 'success'
            : scope.row.TaskStatus == 100
              ? 'info'
              : scope.row.TaskStatus == 200
                ? 'warning'
                : scope.row.TaskStatus == 300
                  ? ''
                  : 'danger'
            ">
            {{
              scope.row.TaskStatus == 0
                ? "已开盘"
                : scope.row.TaskStatus == 100
                  ? "未开盘"
                  : scope.row.TaskStatus == 200
                    ? "暂停"
                    : scope.row.TaskStatus == 300
                      ? "完成"
                      : "未设置"
            }}
          </el-tag>
          <div title="计划时间">{{ formatTime(scope.row) }}</div>
          <div title="附注">{{ scope.row.Memo }}</div>
        </template>
      </el-table-column>
      <el-table-column label="工程客户信息">
        <template slot-scope="scope" style="max-height: 100%">
          <div>
            工程：
            <span class="table-value">
              {{ scope.row.ProjectName }}
            </span>
          </div>
          <div>
            客户：
            <span class="table-value">
              {{ scope.row.ClientName }}
            </span>
          </div>
          <div>
            地址：
            <span class="table-value">
              {{ scope.row.ConstructionAddress }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="强度等级/施工信息">
        <template slot-scope="scope">
          <div>
            强度等级:
            <span class="table-value">
              {{ scope.row.GradeName }} {{ scope.row.SpecMtlName }}
            </span>
            浇筑方式:
            <span class="table-value">
              {{ scope.row.WorkMethodName }}
            </span>
            施工部位:
            <span class="table-value">
              {{ scope.row.ProjectPart }}
            </span>
            泵送:
            <el-tag :type="scope.row.IsPumping == 1 ? 'success' : 'info'" disable-transitions>
              {{ scope.row.IsPumping == 1 ? "是" : "否" }}
            </el-tag>
            计划、完成方量:
            <span class="table-value">
              {{ scope.row.PlanQuantity }}/{{ scope.row.QuantityTotal }}
            </span>
            备注:
            <span class="table-value">
              {{ scope.row.Remark }}
            </span>
            所属:
            <span class="table-value">
              {{ scope.row.OrgName }}
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="RecipeCodes" label="配方">
        <template prop="RecipeCodes" slot-scope="scope">
          <span v-for="item in getRecipeCodesInString(scope.row.RecipeCodes)" :key="item.StationLineID">
            <el-link type="primary" @click="
              () => {
                currentRow = scope.row;
                handleDetailById(item);
              }
            " style="margin: 0 5px">
              {{ item.StationLineName }}
            </el-link>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link v-if="
            canEdit &&
            ((scope.row.ApprovalStatus == 0 &&
              currentuser.uID == scope.row.CreateUserID) ||
              !canApproval) &&
            scope.row.Status == 0
          " type="primary" @click="
            () => {
              currentRow = scope.row;
              handleEdit();
            }
          ">
            编辑
          </el-link>
          <el-link v-if="
            canEdit &&
            ((scope.row.ApprovalStatus == 0 &&
              currentuser.uID == scope.row.CreateUserID) ||
              !canApproval) &&
            scope.row.Status == 0
          " type="primary" @click="
            () => {
              currentRow = scope.row;
              handleFiled(-1);
            }
          ">
            归档
          </el-link>
          <el-link v-if="
            canEdit &&
            ((scope.row.ApprovalStatus == 0 &&
              currentuser.uID == scope.row.CreateUserID) ||
              !canApproval) &&
            scope.row.Status == -1
          " type="primary" @click="
            () => {
              currentRow = scope.row;
              handleFiled(0);
            }
          ">
            取消归档
          </el-link>
          <el-link v-if="
            canDelete &&
            ((scope.row.ApprovalStatus == 0 &&
              currentuser.uID == scope.row.CreateUserID) ||
              !canApproval)
          " type="danger" @click="
            () => {
              sels.push(scope.row);
              handleDel();
            }
          ">
            删除
          </el-link>
          <!-- <el-link
            type="primary"
            v-if="scope.row.ApprovalStatus == 999 || !canApproval"
            @click="
              () => {
                showProdpeice(scope.row);
              }
            "
          >
            绑定配比
          </el-link> -->
          <el-link @click="
            () => {
              currentRow = scope.row;
              handleCopy();
            }
          " type="primary">
            复制
          </el-link>
          <el-link type="primary" v-if="
            canApproval &&
            scope.row.ApprovalStatus == 0 &&
            currentuser.uID == scope.row.CreateUserID
          " @click="
            () => {
              handleWorkflow(scope.row);
            }
          ">
            提交工作流
            <span style="color: red">{{ scope.row.ApprovalText }}</span>
          </el-link>
          <el-link type="primary" v-if="canApproval && scope.row.ApprovalStatus > 0" @click="
            () => {
              workflowPace(scope.row);
            }
          ">
            审批信息
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="filters.intPageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>
    <!--新增界面-->
    <el-dialog :title="isEdit ? '编辑' : '新增'" :visible.sync="addFormVisible" v-model="addFormVisible"
      :close-on-click-modal="false" width="90%">
      <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm" size="mini">
        <el-form-item v-if="!isEdit" label="智能识别">
          <el-input v-model="taskInfo" type="textarea"></el-input>
          <el-button type="primary" @click="checkProdTaskInfo()" :loading="addLoading">
            识别
          </el-button>
        </el-form-item>
        <el-form-item label="工程名称" prop="ProjectName">
          <el-input v-model="addForm.ProjectName" class="input-select" :readonly="isEdit" />
          <el-button type="primary" @click="visibleDialog = true" :loading="addLoading">
            选择
          </el-button>
        </el-form-item>
        <el-row>
          <el-col :span="16">
            <el-form-item label="客户名称">
              <el-input v-model="addForm.ClientName" :readonly="isEdit"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属机构">
              <template>
                <el-select v-model="addForm.OrgID" filterable placeholder="请选择" @change="selectOrg">
                  <el-option v-for="item in orgList" :key="item.Id" :label="item.Name" v-model="item.Id"></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="计划方量" prop="PlanQuantity">
              <el-input v-model="addForm.PlanQuantity"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="计划时间" prop="PlanDate">
              <el-date-picker v-model="addForm.PlanDate" type="datetime" placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss" class="date-style"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="坍落度" prop="TLD">
              <template>
                <el-select v-model="addForm.TLD" filterable placeholder="请选择" @change="selectTld">
                  <el-option v-for="item in baseData.TldList" :key="item.Id + '_tld'" :label="item.Name"
                    v-model="item.Id"></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="强度等级" prop="GradeID">
              <template>
                <el-select v-model="addForm.GradeID" filterable placeholder="请选择" @change="selectGrade">
                  <el-option v-for="item in baseData.GradeList" :key="item.Id + '_qd'" :label="item.Name"
                    v-model="item.Id"></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="">
              <el-switch v-model="addForm.IsPumping" :active-value="1" :inactive-value="0" active-text="泵送"
                inactive-text="非泵" @change="selectIsPumping"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="浇筑方式" prop="WorkMethodID">
              <template>
                <el-select v-model="addForm.WorkMethodID" filterable placeholder="请选择" @change="selectPouringMethod">
                  <el-option v-for="item in addForm.IsPumping != undefined &&
                    addForm.IsPumping != null
                    ? baseData.PouringMethodList.filter(
                      (e) => e.IsPumping == addForm.IsPumping
                    )
                    : baseData.PouringMethodList" :key="item.Id + '_jz'" :label="item.Name"
                    v-model="item.Id"></el-option>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="施工部位" prop="ProjectPart">
          <el-input v-model="addForm.ProjectPart"></el-input>
          <!-- <template>
            <el-select
              v-model="addForm.ProjectPart"
              filterable
              placeholder="请选择"
              allow-create
              default-first-option
            >
              <el-option
                v-for="item in baseData.ProjectPartList"
                :key="item.Name + '_bw'"
                :label="item.Name"
                v-model="item.Name"
              ></el-option>
            </el-select>
          </template> -->
        </el-form-item>
        <el-form-item label="施工单位" prop="ProjectCmpy">
          <el-input v-model="addForm.ProjectCmpy"></el-input>
        </el-form-item>
        <el-form-item label="特殊材料">
          <el-checkbox-group v-model="specMtlIDList">
            <el-checkbox v-for="item in baseData.SpecialMaterialList" :label="item.Id" :key="item.Id + '_ts'"
              @change="changeSpecialMaterial(item, $event)">
              {{ item.Name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="发货备注">
          <el-input v-model="addForm.Remark"></el-input>
        </el-form-item>
        <el-form-item label="附注">
          <el-input v-model="addForm.Memo"></el-input>
        </el-form-item>
        <el-form-item label="任务标题">
          <el-input v-model="addForm.Title"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="施工地址">
              <el-input v-model="addForm.ConstructionAddress"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运输距离">
              <el-input v-model="addForm.Distance"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="addForm.ContactName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话">
              <el-input v-model="addForm.ContactPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="isShowDetail" v-model="isShowDetail" :close-on-click-modal="false"
      append-to-body>
      <table class="table-bordered" style="">
        <tr>
          <th>客户名称</th>
          <td>{{ DetailDm.ClientName }}</td>

          <th>工程名称</th>
          <td>{{ DetailDm.ProjectName }}</td>
        </tr>
        <tr>
          <th>计划方量</th>
          <td>{{ DetailDm.PlanQuantity }}</td>
          <th>计划时间</th>
          <td>{{ DetailDm.PlanDate }}</td>
        </tr>

        <tr>
          <th>坍落度</th>
          <td>{{ DetailDm.TLD }}</td>
          <th>强度等级</th>
          <td>{{ DetailDm.GradeName }} / {{ DetailDm.SpecMtlName }}</td>
        </tr>
        <tr>
          <th>是否泵送</th>
          <td>{{ DetailDm.IsPumping == 1 ? "是" : "否" }}</td>
          <th>浇筑方式</th>
          <td>{{ DetailDm.WorkMethodName }}</td>
        </tr>
        <tr>
          <th>施工地址</th>
          <td>{{ DetailDm.ConstructionAddress }}</td>
          <th>施工部位</th>
          <td>{{ DetailDm.ProjectPart }}</td>
        </tr>
        <tr>
          <th>联系人</th>
          <td>{{ DetailDm.ContactName }}</td>
          <th>联系电话</th>
          <td>{{ DetailDm.ContactPhone }}</td>
        </tr>
        <tr>
          <th>施工单位</th>
          <td>{{ DetailDm.ProjectCmpy }}</td>
          <th>备注</th>
          <td>{{ DetailDm.Remark }}</td>
        </tr>
        <tr>
          <th>任务标题</th>
          <td>{{ DetailDm.Title }}</td>
          <th>运输距离</th>
          <td>{{ DetailDm.Distance }}</td>
        </tr>
      </table>
    </el-dialog>

    <TableDataDialog title="合同选择" :visibleDialog="visibleDialog" :queryMethod="queryData" :columns="{
      ProjectName: {
        label: '工程名称',
      },
      ClientName: {
        label: '客户名称',
      },
      Remark: {
        label: '备注',
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建人',
      },
    }" @getDialogVisible="setVisible" @callback="dialogCallback"></TableDataDialog>

    <!-- 审批详情 -->
    <el-dialog title="提交审批流" :visible.sync="isShowWorkflow" v-model="isShowWorkflow" :close-on-click-modal="false"
      append-to-body>
      <!--列表-->
      <el-table :data="workflowHistryList" highlight-current-row style="width: 100%" :border="true">
        <el-table-column prop="CreateUser" label="审批人"></el-table-column>
        <el-table-column prop="ApprovalContent" label="批注"></el-table-column>
        <el-table-column prop="OpType" label="审批状态" width="">
          <template slot-scope="scope">
            {{
              scope.row.OpType == 100
                ? "提交"
                : scope.row.OpType == 200
                  ? "通过"
                  : "驳回"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="审批时间" sortable></el-table-column>
      </el-table>
      <el-form v-if="showApprovalRecord" :model="approvalRecord" label-width="120px">
        <el-form-item label="批注" prop="ApprovalContent">
          <el-input type="textarea" v-model="approvalRecord.ApprovalContent" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div v-if="showApprovalRecord" slot="footer" class="dialog-footer">
        <el-button @click.native="isShowWorkflow = false">取消</el-button>
        <el-button type="primary" @click.native="addWfSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog title="历史配比" :visible.sync="isShowRecipeHistryDetail" v-model="isShowRecipeHistryDetail"
      :close-on-click-modal="false" append-to-body>
      <table class="table-bordered" style="">
        <tr>
          <th>任务单</th>
          <td>{{ taskdM.Title }}-{{ taskdM.Code }}</td>
          <th>工程名称</th>
          <td>{{ taskdM.ProjectName }}</td>
        </tr>
        <tr>
          <th>施工部位</th>
          <td>{{ taskdM.ProjectPart }}</td>
          <th>备注</th>
          <td>{{ taskdM.Remark }}</td>
        </tr>
        <tr>
          <th>强度等级</th>
          <td>{{ taskdM.GradeName }}/{{ taskdM.SpecMtlName }}</td>
          <th>浇筑方式</th>
          <td>{{ taskdM.WorkMethodName }}</td>
        </tr>
        <tr>
          <th>坍 落 度</th>
          <td>{{ taskdM.TLD }}</td>
          <th>计划方量/距离</th>
          <td>{{ taskdM.PlanQuantity }} / {{ taskdM.Distance }}</td>
        </tr>
      </table>
      <span>
        {{ historyCurrentStationLineName }}
        <el-tag type="danger">只显示最近十条修改记录</el-tag>
      </span>
      <el-divider></el-divider>
      <el-collapse accordion v-model="showHistrySub">
        <el-collapse-item v-for="(item, index) in prodRecipeHistoryDetailList" :key="'History_' + index" :name="index">
          <template slot="title">
            <el-tag type="success" v-if="
              item.prodRecipeSubT != null && item.prodRecipeSubT.length > 0
            ">
              混凝土:{{ item.prodRecipeMain.TConsultRecipeTitle }} A掺量:{{
                item.prodRecipeMain.TAProportion
              }}
              {{ item.prodRecipeMain.TTLD }}
            </el-tag>
            <el-tag type="info" v-if="
              item.prodRecipeSubS != null && item.prodRecipeSubS.length > 0
            ">
              砂浆配比:{{ item.prodRecipeMain.SConsultRecipeTitle }} A掺量:{{
                item.prodRecipeMain.SAProportion
              }}
              {{ item.prodRecipeMain.STLD }}
            </el-tag>
            <el-tag :type="item.prodRecipeMain.Transfer == 1 ? 'success' : 'warning'">
              {{ item.prodRecipeMain.Transfer == 1 ? "已传送" : "未传送" }}
            </el-tag>
            <el-tag :type="item.prodRecipeMain.Status == -1 ? 'warning' : 'success'">
              {{ item.prodRecipeMain.Status == -1 ? "已归档" : "未归档" }}
            </el-tag>
            <el-tag type="danger">
              创建时间:{{ item.prodRecipeMain.CreateTime }}
            </el-tag>

            <i class="header-icon el-icon-info"></i>
          </template>
          <div v-if="item.prodRecipeSubT != null && item.prodRecipeSubT.length > 0">
            <h4>混凝土信息</h4>
            <table class="table-bordered" style="">
              <tr>
                <th>搅拌时间</th>
                <td>
                  {{ item.prodRecipeMain.TMixTime }}
                </td>
                <th>创建人</th>
                <td>{{ item.prodRecipeMain.CreateUser }}</td>
                <th>坍落度</th>
                <td>{{ item.prodRecipeMain.TTLD }}</td>
                <th>备注</th>
                <td>{{ item.prodRecipeMain.TRemark }}</td>
              </tr>
            </table>
            <h4>混凝土配比明细</h4>
            <el-table :data="item.prodRecipeSubT">
              <el-table-column prop="MatName" label="物资名称"></el-table-column>
              <el-table-column prop="WarehouseName" label="仓库名称"></el-table-column>
              <el-table-column prop="MatGrade" label="物资规格"></el-table-column>
              <el-table-column prop="Quantity" label="理论用量"></el-table-column>
              <el-table-column prop="ActualQuantity" label="实际用量"></el-table-column>
            </el-table>
            <el-form label-width="120px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="">
                    容重：{{ item.prodRecipeMain.TBulkDensity }}Kg 砂率：{{
                      item.prodRecipeMain.TSL
                    }}
                    水胶比：{{ item.prodRecipeMain.TSJB }} F：{{
                      item.prodRecipeMain.TFProportion
                    }}
                    K：{{ item.prodRecipeMain.TKProportion }} A：{{
                      item.prodRecipeMain.TAProportion
                    }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div v-if="item.prodRecipeSubS != null && item.prodRecipeSubS.length > 0">
            <h4>砂浆信息</h4>
            <table class="table-bordered" style="">
              <tr>
                <th>搅拌时间</th>
                <td>
                  {{ item.prodRecipeMain.SMixTime }}
                </td>
                <th>坍落度</th>
                <td>{{ item.prodRecipeMain.STLD }}</td>
                <th>创建人</th>
                <td>{{ item.prodRecipeMain.CreateUser }}</td>
                <th>备注</th>
                <td>{{ item.prodRecipeMain.SRemark }}</td>
              </tr>
            </table>
            <h4>砂浆配比明细</h4>
            <el-table :data="item.prodRecipeSubS">
              <el-table-column prop="MatName" label="物资名称"></el-table-column>
              <el-table-column prop="WarehouseName" label="仓库名称"></el-table-column>
              <el-table-column prop="MatGrade" label="物资规格"></el-table-column>
              <el-table-column prop="Quantity" label="理论用量"></el-table-column>
              <el-table-column prop="ActualQuantity" label="实际用量"></el-table-column>
            </el-table>
            <el-form label-width="120px">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="">
                    容重：{{ item.prodRecipeMain.SBulkDensity }}Kg 砂率：{{
                      item.prodRecipeMain.TSL
                    }}
                    水胶比：{{ item.prodRecipeMain.SSJB }} F：{{
                      item.prodRecipeMain.TFProportion
                    }}
                    K：{{ item.prodRecipeMain.SKProportion }} A：{{
                      item.prodRecipeMain.SAProportion
                    }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-dialog>
  </section>
</template>

<script>
//引入ProdTask.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/prodTask";
import * as apiRecipe from "../../api/prodRecipe";
import * as wfapi from "../../api/approvalRecord";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import TableDataDialog from "../../components/TableDataDialog";
import { getSelectListPage } from "../../api/saleContract";
import util from "../../../util/date";
import {
  getProdRecipeDetail,
  sendTask,
  getProdRecipeGet,
} from "../../api/RecipeMappingTask";
export default {
  components: { Toolbar, TableDataDialog },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        orgCode: "",
        intPageSize: 30,
        page: 1,
        startTime: "",
        endTime: "",
        status: 0,
        taskStatus: -999,
      },
      prodTask: [],
      baseData: [], //任务单基础数据
      orgList: JSON.parse(localStorage.sysOrgs),
      total: 0,
      specMtlIDList: [],
      specMtlNameList: [],
      listLoading: false,
      sels: [], //列表选中列
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        ProjectName: [
          { required: true, message: "请选择工程名称", trigger: "blur" },
        ],
        PlanDate: [
          {
            required: true,
            message: "计划时间",
            trigger: "date",
          },
        ],
        TLD: [{ required: true, message: "请选择坍落度", trigger: "blur" }],
        GradeID: [
          { required: true, message: "请选择强度等级", trigger: "blur" },
        ],
        ProjectPart: [
          { required: true, message: "请输入施工部位", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {},
      visibleDialog: false,
      pbvisibleDialog: false,
      specMtlID: [],
      specMtlName: [],
      isShowDetail: false,
      DetailDm: {},
      isEdit: false, //是否为编辑
      isShowRecipeHistryDetail: false, //师否现实配比历史信息
      taskdM: {},
      prodRecipeHistoryDetailList: [], //配比历史信息
      historyCurrentStationLineName: "", //历史配比所属生产线
      showHistrySub: [0], //默认展开历史记录中的第一条
      ProdRecipeTablePageInfo: {
        page: 1,
        pagesize: 10,
        gradeName: "",
        title: "",
      },
      ProdRecipeDetail: {
        ProdRecipeSubList: [],
        ProdRecipe: {},
      },
      visibleDiaInitQuery: "",
      approvalCompetencesList: [], //审批信息
      currentuser: { uID: 0 }, //当前用户信息
      workflowHistryList: [], //工作流历史信息
      isShowWorkflow: false, //是否显示工作流详情
      approvalRecord: {}, //审批信息
      showApprovalRecord: true, //是否显示审批信息
      taskInfo: null,
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex(
        (s) => s.name === "编辑" || s.name === "修改"
      );
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
    canApproval() {
      return this.approvalCompetencesList.length > 0;
    },
  },
  methods: {
    //格式化RecipeCodes
    getRecipeCodesInString(str) {
      if (str && str != "-1") {
        return JSON.parse(str);
      }
      return {};
    },
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    // //工具条绑定事件方法
    // callFunction(item) {
    //   this.filters = {
    //     name: item.search,
    //   };
    //   this[item.Func].apply(this, item);
    // },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.filters.page = val;
      this.getProdTask();
    },
    //获取任务
    getProdTask(optype) {
      if (optype == 1) {
        this.filters.page = 1;
      }
      let para = this.filters;
      this.listLoading = true;
      api.getProdTaskListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.prodTask = res.data.response.data;
        this.listLoading = false;
        this.currentRow = null;
        this.sels = [];
      });
    },
    getBaseData() {
      api.getGetProdTaskBaseData().then((res) => {
        this.baseData = res.data.response;
      });
    },
    checkProdTaskInfo() {
      let para = { inputText: this.taskInfo };
      api.checkProdTask(para).then((res) => {
        if (res.data.success) {
          if (!this.addForm.ClientName) {
            this.addForm.ClientName = res.data.response.ClientName;
          }
          if (!this.addForm.ProjectCmpy) {
            this.addForm.ProjectCmpy = res.data.response.ProjectCmpy;
          }
          if (!this.addForm.ProjectName) {
            this.addForm.ProjectName = res.data.response.ProjectName;
          }
          if (!this.addForm.ProjectPart) {
            this.addForm.ProjectPart = res.data.response.ProjectPart;
          }
          if (!this.addForm.PlanQuantity || !this.addForm.PlanQuantity == 0) {
            this.addForm.PlanQuantity = res.data.response.PlanQuantity;
          }
          if (!this.addForm.ContactPhone) {
            this.addForm.ContactPhone = res.data.response.ContactPhone;
          }
          if (!this.addForm.ContactName) {
            this.addForm.ContactName = res.data.response.ContactName;
          }
          if (!this.addForm.Remark) {
            this.addForm.Remark = res.data.response.Remark;
          }
          if (!this.addForm.ConstructionAddress) {
            this.addForm.ConstructionAddress = res.data.response.ConstructionAddress;
          }
        }
        //this.addForm = res.data.response;
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteProdTask(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getProdTask();
          });
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示历史审批信息
    workflowPace(row) {
      this.showApprovalRecord = false;
      this.isShowWorkflow = true;
      let para = { opId: row.Id, dataType: 100 };
      wfapi.getApprovalRecordList(para).then((res) => {
        this.workflowHistryList = res.data.response;
      });
    },
    //提交任务单
    handleWorkflow(row) {
      this.showApprovalRecord = true;
      this.isShowWorkflow = true;
      let para = { opId: row.Id, dataType: 100 };
      this.approvalRecord.DataType = 100; //任务单类型为100
      this.approvalRecord.DataID = row.Id;
      this.approvalRecord.OpType = 100; //审核通过类型为100
      //获取当前审批人最大可以讲条目审批到的节点
      this.approvalRecord.OpNode = Math.max.apply(
        Math,
        this.approvalCompetencesList.map((item) => {
          return item.OpNode;
        })
      );
      wfapi.getApprovalRecordList(para).then((res) => {
        this.workflowHistryList = res.data.response;
      });
      //需要一个弹出框，显示任务信息，显示后续审批人信息,一个请求获取审核记录，一个当前审核备注
      //一个提交按钮，一个取消按钮
      //点击提交按钮后，当前数据状态变成我的审批权限中的最大值
    },
    addWfSubmit() {
      this.addLoading = true;

      let para = Object.assign({}, this.approvalRecord);

      let user = JSON.parse(window.localStorage.user);

      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }

      wfapi
        .addApprovalRecord(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.isShowWorkflow = false;
            this.getProdTask();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .finally(() => {
          this.addLoading = false;
        });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.isEdit = true;
      this.addFormVisible = true;
      this.specMtlID = [];
      this.specMtlName = [];
      this.specMtlIDList = [];
      this.addForm = Object.assign({}, row);
      if (
        row.SpecMtlID != undefined &&
        row.SpecMtlID != null &&
        row.SpecMtlID != ""
      ) {
        this.specMtlIDList = row.SpecMtlID.split(",");
        this.specMtlID = this.specMtlIDList;
      }
      if (
        row.SpecMtlName != undefined &&
        row.SpecMtlName != null &&
        row.SpecMtlName != ""
      ) {
        this.specMtlName = row.SpecMtlName.split(",");
      }
    },
    handleCopy() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要复制的一行数据！",
          type: "error",
        });

        return;
      }
      this.isEdit = false;
      this.addFormVisible = true;
      this.addForm = Object.assign({}, row);
      this.addForm.PlanDate = null;
      this.addForm.QuantityTotal = 0;
      this.addForm.VehiclesTotal = 0;
      this.addForm.RecipeCodes = null;
      this.addForm.UpdateUser = null;
      this.addForm.UpdateUserID = null;
      this.addForm.UpdateTime = null;
      this.addForm.ApprovalStatus = null;

      if (
        row.SpecMtlID != undefined &&
        row.SpecMtlID != null &&
        row.SpecMtlID != ""
      ) {
        this.specMtlIDList = row.SpecMtlID.split(",");
        this.specMtlID = this.specMtlIDList;
      }
      if (
        row.SpecMtlName != undefined &&
        row.SpecMtlName != null &&
        row.SpecMtlName != ""
      ) {
        this.specMtlName = row.SpecMtlName.split(",");
      }
    },
    //显示新增界面
    handleAdd() {
      this.isEdit = false;
      this.addFormVisible = true;
      this.addForm = {
        ConstructionAddress: "",
        ContactName: "",
        ContactPhone: "",
        ProjectName: "",
        ProjectCmpy: "",
        IsPumping: 0,
        Remark: '',
        ClientName: '',
      };
      this.specMtlID = [];
      this.specMtlName = [];
      this.specMtlIDList = [];
      if (localStorage.currentOrg) {
        let currentOrg = JSON.parse(localStorage.currentOrg);
        this.addForm.OrgID = currentOrg.Id;
        this.addForm.OrgCode = currentOrg.OrgCode;
        this.addForm.OrgName = currentOrg.Name;
      } else if (localStorage.sysOrgs) {
        let sysOrgs = JSON.parse(localStorage.sysOrgs);
        this.addForm.OrgID = sysOrgs[0].Id;
        this.addForm.OrgCode = sysOrgs[0].OrgCode;
        this.addForm.OrgName = sysOrgs[0].Name;
      }
    },
    //执行新增/编辑
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (this.approvalCompetencesList.length > 0) {
            this.addForm.ApprovalStatus = 0;
          } else {
            this.addForm.ApprovalStatus = 999;
          }
          this.addLoading = true;
          let para = Object.assign({}, this.addForm);
          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          if (this.isEdit) {
            api
              .editProdTask(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getProdTask();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.addLoading = false;
              });
          } else {
            api
              .addProdTask(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getProdTask();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.addLoading = false;
              });
          }
        }
      });
    },
    //归档
    handleFiled(status) {
      this.addLoading = true;
      this.currentRow.Status = status;
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .editProdTask(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getProdTask();
        })
        .finally(() => {
          this.addLoading = false;
        });
    },
    // 显示窗口
    handleDetail(row) {
      this.DetailDm = row;
      this.isShowDetail = !this.isShowDetail;
    },
    // 根据Id显示配比详情显示窗口
    handleDetailById(item) {
      this.taskdM = this.currentRow;
      this.isShowRecipeHistryDetail = !this.isShowRecipeHistryDetail;
      let para = { recipeCode: item.RecipeCode };
      this.listLoading = true;
      this.prodRecipeHistoryDetailList = [];
      this.historyCurrentStationLineName = item.StationLineName;
      apiRecipe.getHistryByPage(para).then((res) => {
        this.prodRecipeHistoryDetailList = res.data.response;
        this.listLoading = false;
      });
    },
    // 获取配方详情
    getProdRecipeDetail(id) {
      let para = {
        id: id,
      };
      getProdRecipeDetail(para).then((data) => {
        if (!data.data.success) {
          this.ProdRecipeTable = [];
          tihs.$message("获取失败");
          return;
        }
        this.ProdRecipeDetail = data.data.response;
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.filters.intPageSize = size;
      this.getProdTask(1);
    },
    dialogCallback(data) {
      if (data.length > 0) {
        this.addForm.ProjectName = data[0].ProjectName;
        this.addForm.ProjectID = data[0].ProjectID;
        this.addForm.ClientName = data[0].ClientName;
        this.addForm.ClientID = data[0].ClientID;
        this.addForm.SaleContractCode = data[0].Code;
        this.addForm.SaleContractID = data[0].Id;
        this.addForm.ConstructionAddress = data[0].ProjectAddress;
        this.addForm.ContactName = data[0].ContactName;
        this.addForm.ContactPhone = data[0].ContactPhone;
        this.addForm.ProjectCmpy = data[0].ClientName;
        this.addForm.Remark = data[0].Remark;
      }
      this.visibleDialog = false;
    },
    queryData(params) {
      if (localStorage.currentOrg) {
        params.OrgId = JSON.parse(localStorage.currentOrg).Id;
      } else if (localStorage.sysOrgs) {
        params.OrgId = JSON.parse(localStorage.sysOrgs)[0].Id;
      }

      return getSelectListPage(params);
    },
    setVisible(val) {
      this.visibleDialog = val;
    },
    //强度等级改变时触发
    selectGrade(id) {
      var value = this.baseData.GradeList.filter((e) => e.Id == id)[0];
      this.addForm.GradeID = value.Id;
      this.addForm.GradeName = value.Name;
    },
    //组织机构改变时触发
    selectOrg(id) {
      var value = this.orgList.filter((e) => e.Id == id)[0];
      this.addForm.OrgID = value.Id;
      this.addForm.OrgCode = value.OrgCode;
      this.addForm.OrgName = value.Name;
    },
    //坍落度改变时触发
    selectTld(id) {
      var value = this.baseData.TldList.filter((e) => e.Id == id)[0];
      this.addForm.TLD = value.Name;
    },
    //浇筑方式改变时触发
    selectPouringMethod(id) {
      var value = this.baseData.PouringMethodList.filter((e) => e.Id == id)[0];
      this.addForm.WorkMethodID = value.Id;
      this.addForm.WorkMethodName = value.Name;
    },
    //是否泵送状态改变时，浇筑方式自动筛选
    selectIsPumping(value) { },
    //特殊材料选择
    changeSpecialMaterial(value, isTrue) {
      if (isTrue) {
        this.specMtlID.push(value.Id);
        this.specMtlName.push(value.Name);
      } else {
        this.specMtlID.splice(
          this.specMtlID.findIndex((x) => x === value.Id),
          1
        );
        this.specMtlName.splice(
          this.specMtlName.findIndex((x) => x === value.Name),
          1
        );
      }
      this.addForm.SpecMtlID = this.specMtlID.toString();
      this.addForm.SpecMtlName = this.specMtlName.toString();
    },
    formatTime(row, column) {
      return !row.PlanDate || row.PlanDate == ""
        ? ""
        : util.formatDate.format(new Date(row.PlanDate), "yyyy-MM-dd hh:mm");
    },
    bindRecipeSubmit(taskId, recipeid) {
      this.addLoading = true;
      let para = {
        taskIds: taskId,
        recipeId: recipeid,
      };
      sendTask(para)
        .then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getProdTask();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .finally(() => {
          this.addLoading = false;
        });
    }, formatDateYMD(date) {
      function padZero(num) {
        return num < 10 ? '0' + num : num;
      }
      var year = date.getFullYear();
      var month = padZero(date.getMonth() + 1); // 月份是从0开始的
      var day = padZero(date.getDate());
      var hours = padZero(date.getHours());
      var minutes = padZero(date.getMinutes());
      var seconds = padZero(date.getSeconds());

      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    },
  },
  mounted() {
    /*获取任务单基础档案*/
    if (localStorage.currentOrg) {
      this.filters.orgCode = JSON.parse(localStorage.currentOrg).OrgCode;
    } else if (localStorage.sysOrgs) {
      this.filters.orgCode = JSON.parse(localStorage.sysOrgs)[0].OrgCode;
    }
    if (window.localStorage.user) {
      this.currentuser = JSON.parse(window.localStorage.user);
    }
    /*获取审批权限*/
    if (localStorage.ApprovalCompetences) {
      var listAC = JSON.parse(localStorage.ApprovalCompetences).filter(
        (k) => k.DataType == 100 && k.DataUserID == this.currentuser.uID
      );
      if (listAC && listAC.length > 0) {
        this.approvalCompetencesList = listAC;
      }
    }
    /*获取任务单基础档案*/

    let pastDate = new Date(new Date().setHours(0, 0, 0, 0));
    pastDate.setDate(pastDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.startTime = this.formatDateYMD(pastDate);

    let endDate = new Date(new Date().setHours(23, 59, 59, 0));
    endDate.setDate(endDate.getDate() + 1); //num正数为后一天，负数为前一天
    this.filters.endTime = this.formatDateYMD(endDate);

    this.getProdTask();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getBaseData();
  }, //格式化时间
};
</script>

<style lang="less" scoped>
.input-select {
  width: 300px;
}

.date-style /deep/ .el-input__inner {
  width: 230px !important;
}

.table-value {
  color: #23ade5;
  margin-right: 20px;
}
</style>
